import {FIELD_TYPES as BASIC_FIELD_TYPES} from "@frontend/constants/field-types";

export const FIG_PARSED_FIELD_TYPES = {
  TEXT: 'Text',
  IMAGE: 'Image',
  CANVAS: 'Canvas',
  FRAME: 'Frame',
  RECTANGLE: 'Rectangle',
  VECTOR: 'Vector',
  TEMPLATE: 'Template',
}

export const FIGMA_LAYER_TYPE_TO_BASIC_MAP = {
  [FIG_PARSED_FIELD_TYPES.TEXT]: BASIC_FIELD_TYPES.TEXT,
  [FIG_PARSED_FIELD_TYPES.IMAGE]: BASIC_FIELD_TYPES.IMAGE,
  [FIG_PARSED_FIELD_TYPES.RECTANGLE]: BASIC_FIELD_TYPES.RECTANGLE
}

export const FIG_LAYERS_DATA_TYPES = [
  FIG_PARSED_FIELD_TYPES.TEXT,
  FIG_PARSED_FIELD_TYPES.IMAGE,
  FIG_PARSED_FIELD_TYPES.RECTANGLE,
  FIG_PARSED_FIELD_TYPES.TEMPLATE,
  FIG_PARSED_FIELD_TYPES.VECTOR
]

export const FIG_DATA_TYPE_TO_MODEL = {
  [FIG_PARSED_FIELD_TYPES.CANVAS]: () => require('./models/figma-frame').FigmaFrame,
  [FIG_PARSED_FIELD_TYPES.IMAGE]: () => require('./models/figma-image').FigmaImage,
  [FIG_PARSED_FIELD_TYPES.TEXT]: () => require('./models/figma-text').FigmaText,
  [FIG_PARSED_FIELD_TYPES.FRAME]: () => require('./models/figma-frame').FigmaFrame,
  [FIG_PARSED_FIELD_TYPES.RECTANGLE]: () => require('./models/figma-rectangle').FigmaRectangle,
  [FIG_PARSED_FIELD_TYPES.VECTOR]: () => require('./models/figma-vector').FigmaVector,
  [FIG_PARSED_FIELD_TYPES.TEMPLATE]: () => require('./models/figma-template').FigmaTemplate,
}
